<template>
  <el-container>
    <el-main class="base-background__white">
      <div class="SecretKey_main-div">
        <div v-if="!imageType" class="account_info">
          <h4>{{ $t('computingCluster.secretKey.windowsLoginPassword') }}</h4>
          <div class="password">
            {{ $t('computingCluster.secretKey.password') }}<span>******</span>
            <span class="modify" @click="changeDialogVisible('windows')">{{
                $t('computingCluster.secretKey.modify')
              }}</span>
          </div>
        </div>

        <div v-else>
          <div class="account_info">
            <h4>{{ $t('computingCluster.secretKey.vncAccount') }}</h4>
            <div>
              {{ $t('computingCluster.secretKey.account') }}<span>{{ vncAccount }}</span>
            </div>
            <div class="password">
              {{ $t('computingCluster.secretKey.password') }}<span>******</span>
              <span class="modify" @click="changeDialogVisible('vnc')">{{
                  $t('computingCluster.secretKey.modify')
                }}</span>
            </div>
          </div>

          <div class="account_info">
            <h4>{{ $t('computingCluster.secretKey.serverAccount') }}</h4>
            <div>
              {{ $t('computingCluster.secretKey.account') }}<span>{{ linuxAccount }}</span>
            </div>
            <div class="password">
              {{ $t('computingCluster.secretKey.password') }}<span>******</span>
              <span class="modify" @click="changeDialogVisible('linux')">{{
                  $t('computingCluster.secretKey.modify')
                }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-main>

    <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <div v-loading="loading">
        <el-input v-model="password" :placeholder="$t('computingCluster.secretKey.inputPassword')"
                  show-password></el-input>
        <p v-if="passwordType === 'vnc'" class="base-margin__top-10">
          {{ $t('computingCluster.secretKey.passwordRule1VNC') }}</p>
        <p v-else class="base-margin__top-10">{{ $t('computingCluster.secretKey.passwordRule1') }}</p>
        <p v-if="passwordType !== 'vnc'">{{ $t('computingCluster.secretKey.passwordRule2') }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('computingCluster.secretKey.cancel') }}</el-button>
        <el-button :loading="loading" type="primary" @click="changePwd()">{{
            $t('computingCluster.secretKey.confirm')
          }}</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import {postRequest} from '@/common/libs/request';
import {mapGetters, mapState} from 'vuex';
import {use} from '@tencent/tea-sdk-runner';

export default {
  name: 'SecretKey',
  data() {
    return {
      // 当前的项目id
      projectId: '',
      // vnc账户
      vncAccount: '',
      // vnc密码
      vncPassword: '',
      // linux账户
      linuxAccount: '',
      // linux账户
      linuxPassword: '',
      // 是否显示弹窗
      dialogVisible: false,
      // 密码类型
      passwordType: '',
      // 弹窗title
      dialogTitle: '',
      loading: false,
      // 是否是windows系统
      imageType: '',
      password: '',
      mfaSdk: null, // MFA SDK
      loginType: window.sessionStorage.getItem('loginType'),
    };
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },

  /**
   * 组件创建时初始化
   * 1. 获取当前项目信息
   * 2. 判断系统类型
   * 3. 获取账户名称
   */
  created() {
    const currentProject = this.getCurrentProject();
    // this.imageType = currentProject.env.imageType.toLowerCase().indexOf('windows') === -1;
    this.projectId = currentProject.id;
    this.getAccountName();
  },

  /**
   * 监听器配置
   */
  watch: {
    // 监听当前项目变化
    'app.currentProject'(val) {
      const currentProject = this.getCurrentProject();
      if (currentProject.id !== +this.projectId) {
        this.projectId = val.id;
        // this.imageType = currentProject.env.imageType.toLowerCase().indexOf('windows') === -1;
        this.getAccountName();
      }
    },

    // 监听对话框状态变化
    dialogVisible(val) {
      if (!val) {
        this.password = '';
      }
    },
  },
  methods: {
    /**
     * 显示修改密码对话框
     * @param {string} type - 密码类型(vnc/linux/windows)
     */
    changeDialogVisible(type) {
      this.passwordType = type;
      switch (type) {
        case 'vnc':
          this.dialogTitle = this.$t('computingCluster.secretKey.modifyVNCPassword');
          break;
        case 'linux':
          this.dialogTitle = this.$t('computingCluster.secretKey.modifyServerPassword');
          break;
        case 'windows':
          this.dialogTitle = this.$t('computingCluster.secretKey.modifyWindowsPassword');
      }
      this.dialogVisible = true;
    },

    /**
     * 获取账户名称信息
     */
    getAccountName() {
      postRequest('/api/eda/common/project/getProjectInfo', {
        projectId: this.projectId,
      }).then((res) => {
        this.imageType = res.imagePlatform.toLowerCase().indexOf('windows') === -1;
        this.vncAccount = res?.vncName || '';
        this.linuxAccount = res?.linuxName || '';
      });
    },

    /**
     * 修改密码方法
     * 1. 验证密码格式
     * 2. 腾讯云用户需要MFA认证
     * 3. 提交修改请求
     */
    async changePwd() {
      let reg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{12,30}$/;
      let minLength = 12;
      let maxLength = 30;
      if (this.passwordType === 'vnc') {
        minLength = 6;
        maxLength = 8;
        reg = /^.{6,8}$/;
      }

      // 密码不为空
      if (this.password.trim() === '') {
        this.$message.error(this.$t('computingCluster.secretKey.passwordNotEmpty'));
        return;
      }

      // 密码长度验证
      if (this.password.trim().length < minLength || this.password.trim().length > maxLength) {
        this.$message.error(this.$t('computingCluster.secretKey.passwordLength', {min: minLength, max: maxLength}));
        return;
      }

      // 密码复杂度验证
      if (!reg.test(this.password)) {
        this.$message.error(this.$t('computingCluster.secretKey.passwordComplexity'));
        return;
      }

      // 腾讯云用户需要MFA认证
      if (this.passwordType === 'windows' && this.loginType === 'cloud') {
        try {
          if (!this.mfaSdk) {
            this.mfaSdk = await use('mfa-sdk');
          }
          this.mfaSdk
            .verify({api: 'cvm:ResetInstancesPassword'})
            .then(() => {
              this.editPassword();
            })
            .catch((e) => {
              console.log('Windows登录密码', e, e.innerError);
            });
        } catch (e) {
          this.$message({
            type: 'error',
            message: this.$t('computingCluster.secretKey.mfaFailed'),
          });
        }
      } else {
        await this.editPassword();
      }
    },

    /**
     * 提交密码修改请求
     */
    async editPassword() {
      try {
        this.loading = true;
        await postRequest('/api/eda/common/project/changePwd', {
          projectId: this.projectId,
          newPwd: this.password,
          type: this.passwordType,
        });
        this.loading = false;
        this.$message.success(this.$t('computingCluster.secretKey.passwordChangeSuccess'));
        this.dialogVisible = false;
      } catch (e) {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 最外层盒子css
.el-container {
  height: 100%;
  font-size: 14px;
}

// 主体内容盒子css
.el-main {
  padding: 0;
  overflow: auto;
  height: calc(100vh - 136px);
}

// 主体内容盒子
.SecretKey_main-div {
  background: #fff;
  padding: 20px;
}

// title
h4 {
  font-weight: 700;
  font-family: 'PingFang SC';
  margin-bottom: 24px;
}

// 内容盒子
.account_info {
  margin-top: 34px;
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 32px;

  div {
    padding-left: 28px;
    color: #000;

    span {
      margin-left: 105px;
      color: rgba(0, 0, 0, 0.6);
    }
  }
}

// 密码向上间距
.password {
  margin-top: 20px;
}

// 修改按钮
.modify {
  color: #598dd9 !important;
  cursor: pointer;
}
</style>
